import DropDownTreeControl from './DropDownTreeControl';
import TreeViewControl from './TreeViewControl';
import MultipleTooltipFormControl from './MultipleTooltipFormControl';
import ListControl from './ListControl';
import EntityFieldsControl from './static/EntityFieldsControl';
import ListFieldsControl from './static/ListFieldsControl';
import ActionsControl from './static/ActionsControl';
import ActionRightsControl from './static/ActionRightsControl';
import FormFieldsControl from './static/FormFieldsControl';
import FormControl from './FormControl';
import "isomorphic-fetch";

window.DropDownTreeControl = DropDownTreeControl;
window.TreeViewControl = TreeViewControl;
window.MultipleTooltipFormControl = MultipleTooltipFormControl;
window.ListControl = ListControl;
window.EntityFieldsControl = EntityFieldsControl;
window.ListFieldsControl = ListFieldsControl;
window.ActionsControl = ActionsControl;
window.FormFieldsControl = FormFieldsControl;
window.FormControl = FormControl;
window.ActionRightsControl = ActionRightsControl;